// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ir-0";